import { useMemo } from 'react';
import type { CMSGroupParams } from '@/api/cms/base';
import { groupsExclude, groupsInclude } from '@/helpers/cms';
import { useGetCommonStore } from '@/store/commonStore';

export const useMatchingSection = <T extends CMSGroupParams>(sections: T[]) => {
  const useCommonStore = useGetCommonStore();
  const user = useCommonStore.use.user();
  const isAuthenticated = useCommonStore.use.isAuthenticated();

  const section = useMemo(
    () =>
      sections.find((section) => {
        if (!isAuthenticated && section.showGuestToggle !== undefined) {
          return section.showGuestToggle === true;
        }

        return groupsInclude(user)(section) && groupsExclude(user)(section);
      }),
    [sections, user, isAuthenticated]
  );

  return section;
};
